/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

let hasLoadedInitialPage = false;

exports.onRouteUpdate = ({ location }) => {
  if (!hasLoadedInitialPage) {
    hasLoadedInitialPage = true;
    return;
  }

  if (window.__GOOGLE_TAG_MANAGER_ID__ && window.dataLayer) {
    window.dataLayer.push({
      event: `gatsby-route-change`,
      page_path: location.pathname + location.search + location.hash,
      page_title: document.title,
    });
  }

  if (window.__GOOGLE_ANALYTICS_ID__ && window.gtag) {
    window.gtag(`config`, window.__GOOGLE_ANALYTICS_ID__, {
      page_path: location.pathname + location.search + location.hash,
      page_title: document.title,
    });
  }
};

exports.onClientEntry = () => {
  require('./src/utils/app-click-tracking').installAppClickTracking(window, document);
};
